import { concat, flatten, groupBy, keys } from 'ramda'

import { isEmptyOrNull } from '@/utils'

export const formatFeatures = (
  t,
  isEntireUnit,
  unitFeatures,
  customFeatures
) => {
  const hasUnitFeatures =
    !isEmptyOrNull(unitFeatures) || !isEmptyOrNull(customFeatures)

  const noneAvailable = t(
    'listing:b.listing.view.no_features.text',
    'None available'
  )

  const formatAndConcat = () => {
    const standard = flatten(
      unitFeatures.map(feature => {
        const hasTypes = !isEmptyOrNull(feature.types)
        if (hasTypes) {
          const typeKeys = keys(feature.types)
          return typeKeys.map(key => {
            const count = feature.types[key]
            if (count === 0) return []
            return {
              id: `${key}-${feature.txt_id}`,
              name: `+ ${count} ${t(
                `basic:b.listing.unit_features.${feature.txt_id}.text`,
                feature.name
              )}`,
              type: key
            }
          })
        } else {
          return {
            id: feature.txt_id,
            name: `+ ${t(
              `basic:b.listing.unit_features.${feature.txt_id}.text`,
              feature.name
            )}`,
            type: feature.type
          }
        }
      })
    )
    const custom = customFeatures.map((feature, i) => {
      return {
        id: `custom-${i}`,
        name: `+ ${feature.name}`,
        type: feature.type
      }
    })
    return concat(standard, custom)
  }

  if (isEntireUnit) {
    if (hasUnitFeatures) {
      return formatAndConcat()
    } else {
      return [
        {
          id: 'features-entire-none',
          name: noneAvailable
        }
      ]
    }
  } else {
    const allFeatures = formatAndConcat()
    const groupedFeatures = groupBy(feature => {
      const type = feature.type || 'private'
      return type
    })(allFeatures)
    return {
      private: groupedFeatures.private || [
        {
          id: 'features-private-none',
          name: noneAvailable
        }
      ],
      shared: groupedFeatures.shared || [
        {
          id: 'features-shared-none',
          name: noneAvailable
        }
      ]
    }
  }
}

export const formatUtilities = (
  t,
  isEntireUnit,
  unitUtilities,
  customUtilities
) => {
  const hasUnitUtilities =
    !isEmptyOrNull(unitUtilities) || !isEmptyOrNull(customUtilities)

  const noneAvailable = t(
    'listing:b.listing.view.no_features.text',
    'None available'
  )

  const formatAndConcat = () => {
    const standard = unitUtilities.map(utility => {
      return {
        id: utility.txt_id,
        name: `+ ${t(
          `basic:b.listing.utilities.${utility.txt_id}.text`,
          utility.name
        )}`,
        type: utility.type
      }
    })
    const custom = customUtilities.map((utility, i) => {
      return {
        id: `custom-${i}`,
        name: `+ ${utility.name}`,
        type: utility.type
      }
    })
    return concat(standard, custom)
  }

  if (isEntireUnit) {
    if (hasUnitUtilities) {
      return formatAndConcat()
    } else {
      return [
        {
          id: 'utilities-entire-none',
          name: noneAvailable
        }
      ]
    }
  } else {
    const allUtilities = formatAndConcat()
    const groupedUtilities = groupBy(utility => {
      const type = utility.type || 'included'
      return type
    })(allUtilities)
    return {
      included: groupedUtilities.included || [
        {
          id: 'utilities-included-none',
          name: noneAvailable
        }
      ],
      shared: groupedUtilities.shared || [
        {
          id: 'utilities-shared-none',
          name: noneAvailable
        }
      ],
      metered: groupedUtilities.metered || [
        {
          id: 'utilities-metered-none',
          name: noneAvailable
        }
      ]
    }
  }
}
